<template>
    <div>
        <div v-if="events.length > 0" class="event-slider tw-grid gap-x-2 row-gap-1 tw-relative tw-ml-4 tw-mr-6 tw-grid-cols-1 xs:tw-grid-cols-2 xs:tw-mx-6 device:tw-mx-0" :class="{'compact': compact}">
            <a :href="'/events/' + event.slug" class="card card-shadow tw-pt-0 tw-px-0 event-slider-item tw-flex tw-flex-col tw-relative tw-cursor-pointer hover:tw-opacity-75" v-for="(event, index) in events" :key="event.id">
                <template v-if="(index === 0 && events[index].image !== '' && (events.length === 1 || events[index + 1].image !== '')) || (index === 1 && events[index].image !== '' && (events.length === 1 || events[index - 1].image !== ''))">
                    <div class="card-full-img">
                        <img :src="`${ event.image }?width=652`" :alt="event.title + ' image'">
                    </div>
                </template>
                <div class="card-inner tw-h-full tw-flex tw-flex-col">
                    <div class="tw-flex tw-justify-between">
                        <p class="tw-inline-block tw-mr-3 light-text">
                            <i class="fa fa-calendar-alt tw-mr-2"></i>
                            <span v-text="startDate(event)"></span>
                        </p>
                        <div class="user-icon-previews event-members tw-ml-2">
                            <template v-for="(member, index) in members(event)">
                                <img :src="member.user.avatar" alt="" :key="member.id" onerror="this.src='/img/avatar.png'" v-if="index < 3">
                            </template>
                            <span class="tw-text-sm tw-font-semibold tw-ml-1" v-text="event.members_count"></span>
                        </div>
                    </div>
                    <div class="tw-my-4 tw-flex-1">
                        <h3 class="tw-relative tw-leading-relaxed tw-font-semibold" v-html="event.title"></h3>
                        <div class="tw-flex normal-text tw-mt-2">
                            <p class="event-description" v-html="event.description" v-line-clamp:20="3"></p>
                        </div>
                    </div>
                    <div class="tw-flex tw-mt-2">
                        <div class="pill tw-py-2 tw-text-white tw-mr-2" :style="{ backgroundColor: event.category.color }" v-text="event.category.name"></div>
                        <div class="pill tw-py-2 tw-mr-2 address-pill" v-if="event.online || eventLocation(event) !== ''">
                          <template v-if="event.online">
                            <i class="far fa-globe"></i> {{ translations['events.online'] }}
                          </template>
                          <template v-else-if="eventLocation(event) !== ''">
                            <i class="far fa-map-marker-alt"></i> {{ eventLocation(event) }}
                          </template>
                        </div>
                        <template v-if="event.status === 'private' || event.status === 'secret'">
                            <i class="far mimic-title event-status light-text tw-pt-px tw-rounded-full tw-bg-gray-0 tw-hidden md:tw-flex md:tw-items-center md:tw-justify-center" aria-hidden="true" :class="[{'far fa-lock' : event.status === 'private'}, {'fas fa-eye-slash tw-mt-px': event.status === 'secret'}]">
                                <span v-if="event.status === 'private'" v-text="`${$t('fields.private')} ${$t('events.singular').toLowerCase()}`"></span>
                                <span v-if="event.status === 'secret'" v-text="`${$t('events.secret')}`"></span>
                            </i>
                        </template>
                    </div>
                </div>
            </a>
            <!--<a href="/events" class="discover-more-btn tw-absolute tw-z-10 secondary-c-bg secondary-c-contrast tw-rounded-full tw-flex tw-items-center tw-justify-center tw-cursor-pointer" v-if="events.length >= 2">
                <i class="fa fa-calendar-alt"></i>
            </a>-->
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import moment from 'moment';
    import HuddleEvent from '@/resources/assets/js/vue/lib/models/Event';
    import Global from '../../mixins/Global';
	import Plans from '../../mixins/v2/Plans';

    export default {
        name: 'EventSlider',

        mixins: [ Global, Plans ],

        computed: {
            ...mapState([
                'displayMode',
            ]),

            compact() {
                return this.displayMode === 'small' && !isHelpdesk;
            },

            events() {
               const sortedEvents = HuddleEvent.query().where((event) => {
                    const today = moment(new Date).format('YYYY-MM-DD HH:mm:ss');
                    return moment(event.start_date, 'MMMM DD, YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss') > today;
                }).get().sort((a, b) => new Date(moment(a.created_at, 'YYYY-MM-DD HH:mm:ss').format()) - new Date(moment(b.created_at, 'YYYY-MM-DD HH:mm:ss').format()));

                return sortedEvents.slice(sortedEvents.length - 2, sortedEvents.length).reverse();
            },
        },

        methods: {
            startDate(tEvent) {
              if (tEvent.all_day) {
                return moment(tEvent.start_date, 'MMMM DD, YYYY HH:mm').format("DD MMMM");
              }

              return moment(tEvent.start_date, 'MMMM DD, YYYY HH:mm').format("DD MMMM HH:mm");
            },

            fetchUpcomingEvents() {
                const params = new URLSearchParams();
                const today = moment(new Date).format('YYYY-MM-DD HH:mm:ss');

                params.append('order_by', 'created_at:desc');
                params.append('type', 'home');
                params.append('with', 'memberSelection,category,participation');
                params.append('where_gte', `start_date:${today}`);
                params.append('size', 2);

                HuddleEvent.api().fetch(params, 'discover');
            },

            eventLocation(event) {
                if (event.muncipality !== '') {
                    return event.muncipality;
                } else if (event.province !== '') {
                    return event.province;
                }

                return event.full_address;
            },

            members(tEvent) {
                return tEvent.memberSelection.filter((member) => member.user != null);
            },
        },

        created() {
			if (this.plugins.events && this.hasPlan(5)) {
				this.fetchUpcomingEvents();
			}
        },
    };
</script>

<style lang="scss" scoped>
    .event-slider {
        .discover-more-btn {
            width: 40px;
            height: 40px;
            right: -20px;
            top: 80px;
            border: 4px solid #e9eaee;
        }

        .address-pill {
            text-overflow: ellipsis;
            max-width: 125px;
            overflow: hidden;
            white-space: nowrap;
        }

        &.compact {
            margin: 22px;

            .discover-more-btn {
                @apply tw-border-white;
            }
        }

        .event-description {
            @apply tw-break-normal #{!important};
        }
    }
</style>
